import React from 'react';
import { ExternalLink, ShoppingBag } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import Navigation from './Navigation';
import Footer from './Footer';
import { teamStore } from '../mock';

const StorePage = () => {
  return (
    <div className="page-container">
      <Navigation />
      
      <main className="main-content">
        <section className="page-hero">
          <div className="container">
            <h1 className="page-title">Team Store</h1>
            <p className="page-subtitle">Get your official Panthers gear</p>
          </div>
        </section>

        {/* Categories */}
        <section className="store-categories-section">
          <div className="container">
            <div className="store-categories-banner">
              {teamStore.categories.map((category) => (
                <span key={category} className="category-tag">{category}</span>
              ))}
            </div>
          </div>
        </section>

        {/* Products */}
        <section className="store-products-section">
          <div className="container">
            <h2 className="section-title">Featured Products</h2>
            <div className="store-products-grid">
              {teamStore.featuredProducts && teamStore.featuredProducts.map((product) => (
                <Card key={product.id} className="store-product-card">
                  <CardContent>
                    <div className="product-image-container">
                      <img src={product.image} alt={product.name} className="product-image" />
                    </div>
                    <h3 className="product-name">{product.name}</h3>
                    <p className="product-description">{product.description}</p>
                    <div className="product-price">{product.price}</div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </section>

        {/* Store CTA */}
        <section className="store-cta-section">
          <div className="container">
            <div className="store-cta">
              <ShoppingBag size={48} />
              <h2>Visit Our Full Store</h2>
              <p>Browse our complete collection on SquadLocker</p>
              <Button 
                className="btn-primary btn-large"
                onClick={() => window.open(teamStore.url, '_blank')}
              >
                Shop Now <ExternalLink size={20} />
              </Button>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default StorePage;
